import type {
  DisposalMode,
  FunctionalInspectionType,
  RecordFormat,
  RecordIndexingMode,
  RetentionMode,
  SubjectSelectionMode,
} from '../model/record-config.types';

export const GD_ORIGIN_NAME = 'Gestor de Documentos 2.0';
export const ELECTRONIC_SYSTEM_NAME = GD_ORIGIN_NAME;
export const EDITABLE_IF_API_TYPE_NAME = 'Editável (IF/API)';
export const MAX_PHYSICAL_LOCATIONS = 10;
export const MAX_PROCEDURES = 10;
export const MAX_INDEXING_FIELDS = 3;
export const MIN_INDEXING_SEQUENCE_START = 1;
export const OS_OF_TITLE_LABELS = ['1º título', '2º título', '3º título'] as const;

export const FUNCTIONAL_INSPECTION_TYPE_LABELS: Record<FunctionalInspectionType, string> = {
  NEW_DEVICE: 'Aparelho Novo',
  ASSISTENCE_DEVICE: 'Aparelho de Assistência Técnica',
};

export const FORMAT_OPTIONS: { id: RecordFormat; name: string }[] = [
  { id: 'ELECTRONIC', name: 'Eletrônico' },
  { id: 'PHYSICAL', name: 'Físico' },
  { id: 'ELECTRONIC_PHYSICAL', name: 'Eletrônico/Físico' },
];

export const RECORD_INDEXING_OPTIONS: { id: RecordIndexingMode; name: string }[] = [
  { id: 'USER_DEFINED', name: 'Definido pelo usuário' },
  { id: 'SEQUENTIAL', name: 'Sequencial' },
  { id: 'NON_SEQUENTIAL', name: 'Não sequencial' },
  { id: 'SEQUENTIAL_WITH_DATE', name: 'Sequencial com data' },
];

export const OS_OF_INDEXING_OPTION: { id: RecordIndexingMode; name: string } = {
  id: 'OS_OF',
  name: 'Indexação OS/OF',
};

export function indexingSelectOptions(
  isIfApiType: boolean
): { id: RecordIndexingMode; name: string }[] {
  return isIfApiType ? [OS_OF_INDEXING_OPTION] : RECORD_INDEXING_OPTIONS;
}

export const RETENTION_OPTIONS: { id: RetentionMode; name: string }[] = [
  { id: 'PERMANENT', name: 'Permanente' },
  { id: 'DEFINED', name: 'Definir prazo' },
];

export const DISPOSAL_OPTIONS: { id: DisposalMode; name: string }[] = [
  { id: 'DELETE', name: 'Deletar' },
  { id: 'DESTROY_OR_RECYCLE', name: 'Destruir ou Reciclar' },
  { id: 'DELETE_DESTROY_OR_RECYCLE', name: 'Deletar/Destruir ou Reciclar' },
  { id: 'NOT_APPLICABLE', name: 'Não aplicável' },
];

export const SUBJECT_MODE_OPTIONS: { id: SubjectSelectionMode; name: string }[] = [
  { id: 'SELECT_SUBJECTS', name: 'Selecionar os Cargos e/ou Atividades Funcionais' },
  { id: 'AUTOMATIC', name: 'Automático' },
  { id: 'NOT_APPLICABLE', name: 'Não aplicável' },
];
